import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import locomotiveScroll from './components/LocomotiveScroll';
import Menu from './components/Menu';
import VanillaTilt from 'vanilla-tilt';
import Popup from './components/Popup';
import Search from './components/Search';
import ResponsiveVideo from './components/ResponsiveVideo';
import Modal from './components/Modal';
import UploadFile from './components/UploadFile';
import AutoplayVideos from './components/AutoplayVideos';
import RandomTemplate from './components/RandomTemplate';
import CardsFilter from './components/CardsFilter';

export class Alfred {
	constructor() {
		Promise.all([Alfred.domReady()]).then(() => this.init());
	}

	init() {
		Menu.init();
		UploadFile.init();
		Popup.init();
		ResponsiveVideo.init();
		Search.init();
		RandomTemplate.init();

		new CardsFilter
		new Modal();
		new AutoplayVideos();

		document.dispatchEvent(new Event('bless'));

		VanillaTilt.init(document.querySelectorAll('[data-model-card]'));

		document.fonts.ready.then(() => {
			locomotiveScroll.init();
		});

		// video module > modal single page
		const videoElms = document.querySelectorAll('[data-video-wrapper]');

		if (!videoElms) {
			return;
		}

		videoElms.forEach(element => {

			const button = element.querySelector('[data-play-video]');
			const video = element.querySelector('[data-video]');

			if (button) {
				button.addEventListener('click', e => {
					e.currentTarget.parentElement.classList.add('is-hidden');
					video.play();
				});
			}
		});

		// change label Cookie
		document.getElementById("functional").nextElementSibling.innerHTML = "Functional";
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();